var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-modal',{attrs:{"hide-backdrop":"","value":"","no-close-on-backdrop":"","no-close-on-esc":"","hide-header-close":"","signup":_vm.signup}})
}
var staticRenderFns = []

export { render, staticRenderFns }